import { render, staticRenderFns } from "./LawyerPlan.vue?vue&type=template&id=5928bfd6&scoped=true"
import script from "./LawyerPlan.vue?vue&type=script&lang=js"
export * from "./LawyerPlan.vue?vue&type=script&lang=js"
import style0 from "./LawyerPlan.vue?vue&type=style&index=0&id=5928bfd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5928bfd6",
  null
  
)

export default component.exports